import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QrScannerComponent } from './component/qr-scanner/qr-scanner.component';
import { ChatComponent } from './component/chat/chat.component';

const routes: Routes = [
  // { 
  //   path: 'support/:sessionId', // Will handle deep linking with session ID from QR code
  //   component: ChatComponent 
  // },
  // { 
  //   path: '**', 
  //   redirectTo: '/support/default' 
  // }
  {  
    path: 'support/:name', component: ChatComponent 
  },

  { path: '**', redirectTo: '/support', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
  